import { ObjectFieldsChecker } from "../../../../../../../tools/ObjectFieldsChecker";
import { MarketplaceBuildingItemDto } from "../../../../../../networking/data/responses/marketplace/buildings/MarketplaceBuildingItemDto";
import { MarketplaceBuildingPrice } from "../map/MarketplaceBuildingPrice";
import { MarketplaceBuildingInfo } from "./MarketplaceBuildingInfo";
import { MarketplaceGuestInfo } from "./MarketplaceGuestInfo";
import { PurchaseHistory } from "./PurchaseHistory";

export class MarketplaceBuildingItem {
    public readonly id: string;
    public readonly building: MarketplaceBuildingInfo;
    public readonly price: MarketplaceBuildingPrice;
    public readonly guest: MarketplaceGuestInfo;
    public readonly reservoirOrderId: string;
    public readonly purchaseHistory: Array<PurchaseHistory>;

    public constructor(dto: MarketplaceBuildingItemDto) {
        ObjectFieldsChecker.throwIfInvalidFields(dto, [
            "id",
            "building",
            "guest",
            "price"
        ]);
        this.id = dto.id;
        this.building = new MarketplaceBuildingInfo(dto.building);
        this.price = new MarketplaceBuildingPrice(dto.price);
        this.guest = new MarketplaceGuestInfo(dto.guest);
        this.reservoirOrderId = dto.reservoirOrderId;
        this.purchaseHistory = [];
        for (const purchaseHistoryDto of dto.purchaseHistory) {
            this.purchaseHistory.push(new PurchaseHistory(purchaseHistoryDto));
        }
    }
}
